var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "post post-facebook",
      class: { "response-comment": _vm.responseComment },
    },
    [
      _c(
        "div",
        {
          staticClass: "detail-event-header",
          class: {
            "no-border":
              (_vm.post && Object.keys(_vm.post).length && !_vm.post.message) ||
              _vm.isLoading,
          },
        },
        [
          _vm.currentPage
            ? _c("AvatarComponent", {
                attrs: {
                  typeNetwork: _vm.currentPage.network,
                  urlPicture: _vm.currentPage.avatar,
                },
              })
            : _vm._e(),
          _c("div", { staticClass: "info" }, [
            _vm.currentPage
              ? _c(
                  "div",
                  {
                    staticClass: "namePage",
                    on: { click: _vm.scrollToOriginalComment },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.currentPage.name) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "typeEvent" },
              [
                _c("p", { attrs: { html: "" } }, [
                  _vm._v(_vm._s(_vm.dateFormatPost(_vm.event.date * 1000))),
                ]),
                _vm.event.data &&
                _vm.event.data.changes &&
                _vm.event.data.changes.value
                  ? [
                      _vm.event.data.changes.value.post &&
                      _vm.event.data.changes.value.post.permalink_url
                        ? _c("p", { staticClass: "show-post" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.event.data.changes.value.post
                                    .permalink_url,
                                  target: "_blank",
                                },
                              },
                              [_vm._v("Voir")]
                            ),
                          ])
                        : _vm.event.data.changes.value.link
                        ? _c("p", { staticClass: "show-post" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.event.data.changes.value.link,
                                  target: "_blank",
                                },
                              },
                              [_vm._v("Voir")]
                            ),
                          ])
                        : _vm.event.data.changes.value.comment_id ||
                          _vm.event.data.changes.value.post_id
                        ? _c("p", { staticClass: "show-post" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: `https://www.facebook.com/${
                                    _vm.event.data.changes.value.comment_id ||
                                    _vm.event.data.changes.value.post_id
                                  }`,
                                  target: "_blank",
                                },
                              },
                              [_vm._v("Voir")]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _c(
            "div",
            { staticClass: "selectActionEvent" },
            [
              _c("SelectComponent", {
                attrs: {
                  id: _vm.event._id,
                  changeValueSelect: _vm.changeStatus,
                  data: {
                    treated: _vm.$t("dash.inbox.state.treated"),
                    waiting: _vm.$t("dash.inbox.state.waiting"),
                  },
                  valueSelect: [1, 3].includes(_vm.event.status)
                    ? "treated"
                    : "waiting",
                  positionY: "bottom",
                  positionAuto: false,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "scrollable" },
        [
          _vm.post == false
            ? [_vm._m(0)]
            : _vm.isLoading || !_vm.post || !Object.keys(_vm.post).length
            ? [
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "container-content-comments loading-content" },
                  _vm._l(3, function (index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "container-comment" },
                      [
                        _c("div", { staticClass: "comment" }, [
                          _vm._m(2, true),
                          _c("div", { staticClass: "container-content" }, [
                            _c("div", { staticClass: "content" }, [
                              _c("p", { staticClass: "name-user" }, [
                                _vm._v("www"),
                              ]),
                              _c("p", { staticClass: "text" }, [
                                _vm._v(
                                  _vm._s("w".repeat(5 + Math.random() * 10))
                                ),
                              ]),
                            ]),
                            _vm._m(3, true),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            : _vm.post && Object.keys(_vm.post).length
            ? [
                _c("div", { staticClass: "container-content-post" }, [
                  _c("div", { staticClass: "content-post" }, [
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c("div", { staticClass: "story" }),
                        _vm.post.message
                          ? _c("div", { staticClass: "text" }, [
                              _c("pre", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.messagePostFormat(_vm.post.message)
                                  ),
                                },
                              }),
                            ])
                          : _vm._e(),
                        _vm.post.attachments &&
                        _vm.post.attachments.data &&
                        _vm.post.attachments.data.length &&
                        _vm.post.attachments.data[0].type == "share" &&
                        _vm.post.attachments.data[0].target.url
                          ? _c(
                              "a",
                              {
                                staticClass: "link",
                                attrs: {
                                  href:
                                    _vm.getLastUrlInText(
                                      decodeURIComponent(
                                        _vm.post.attachments.data[0].url
                                      )
                                    ) ||
                                    _vm.getLastUrlInText(_vm.post.message) ||
                                    _vm.post.attachments.data[0].url,
                                  target: "_blank",
                                },
                              },
                              [
                                _vm.post.full_picture
                                  ? _c("div", { staticClass: "banner-link" }, [
                                      _c("img", {
                                        attrs: { src: _vm.post.full_picture },
                                      }),
                                    ])
                                  : _vm._e(),
                                _c("div", { staticClass: "footer-link" }, [
                                  _c(
                                    "p",
                                    { staticClass: "footer-link-domaine" },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.getHostname(
                                              _vm.getLastUrlInText(
                                                decodeURIComponent(
                                                  _vm.post.attachments.data[0]
                                                    .url
                                                )
                                              ) ||
                                                _vm.getLastUrlInText(
                                                  _vm.post.message
                                                ) ||
                                                _vm.post.attachments.data[0].url
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "footer-link-title" },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.post.attachments.data[0].title
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "footer-link-description" },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.post.attachments.data[0]
                                              .description
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm.post.attachments &&
                        _vm.post.attachments.data &&
                        _vm.post.attachments.data.length
                          ? [
                              _vm._l(
                                _vm.post.attachments.data,
                                function (attachments, indexAttachments) {
                                  return [
                                    !attachments.subattachments
                                      ? [
                                          ["photo", "cover_photo"].includes(
                                            attachments.type
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  key:
                                                    "attachments" +
                                                    indexAttachments,
                                                  staticClass: "picture",
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: attachments.media
                                                        .image.src,
                                                    },
                                                  }),
                                                ]
                                              )
                                            : attachments.type == "video_inline"
                                            ? _c(
                                                "div",
                                                {
                                                  key:
                                                    "attachments" +
                                                    indexAttachments,
                                                  staticClass: "video",
                                                },
                                                [
                                                  _c("video", {
                                                    attrs: {
                                                      controls: "",
                                                      src: "attachments.media.source",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : [
                                          _c(
                                            "div",
                                            {
                                              key:
                                                "attachments" +
                                                indexAttachments,
                                              staticClass: "multi-media",
                                            },
                                            [
                                              _c(
                                                "carousel",
                                                {
                                                  attrs: {
                                                    perPage: 1,
                                                    adjustableHeight: true,
                                                    centerMode: true,
                                                  },
                                                },
                                                _vm._l(
                                                  attachments.subattachments
                                                    .data,
                                                  function (
                                                    subattachments,
                                                    index
                                                  ) {
                                                    return _c(
                                                      "Slide",
                                                      { key: "swiper" + index },
                                                      [
                                                        [
                                                          "photo",
                                                          "cover_photo",
                                                        ].includes(
                                                          subattachments.type
                                                        )
                                                          ? _c("img", {
                                                              attrs: {
                                                                src: subattachments
                                                                  .media.image
                                                                  .src,
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                  ]
                                }
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "bar-action-container" }, [
                      _c("div", { staticClass: "btns-action" }, [
                        _c(
                          "div",
                          {
                            staticClass: "reaction",
                            class: {
                              "have-liked": _vm.post.likes.summary.has_liked,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleLikePost(_vm.post.id)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-regular fa-thumbs-up" }),
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.getFormatNumber(
                                    _vm.post.likes.summary.total_count
                                  ) || 0
                                ) +
                                " réaction" +
                                _vm._s(
                                  _vm.post.likes.summary.total_count > 1
                                    ? "s"
                                    : ""
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "comments",
                            on: {
                              click: function ($event) {
                                _vm.autoFocus = true
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-regular fa-comment" }),
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.getFormatNumber(
                                    _vm.post.comments.summary.total_count
                                  ) || 0
                                ) +
                                " commentaire" +
                                _vm._s(
                                  _vm.post.comments.summary.total_count > 1
                                    ? "s"
                                    : ""
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "share",
                            class: [{ shared: _vm.shared }],
                            on: {
                              click: function ($event) {
                                !_vm.shared ? _vm.reshare() : null
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-regular fa-share" }),
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.post.shares && _vm.post.shares.count
                                    ? _vm.getFormatNumber(_vm.post.shares.count)
                                    : 0
                                ) +
                                " partage" +
                                _vm._s(
                                  _vm.post.shares &&
                                    _vm.post.shares.count &&
                                    _vm.post.shares.count > 1
                                    ? "s"
                                    : ""
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    ref: "comments",
                    staticClass: "container-content-comments",
                  },
                  [
                    _vm.post.comments &&
                    _vm.post.comments.data &&
                    _vm.post.comments.data.length
                      ? [
                          _vm._l(
                            _vm.post.comments.data,
                            function (comment, indexComment) {
                              return indexComment == 0 ||
                                _vm.idParentOriginalComment !== comment.id
                                ? _c(
                                    "div",
                                    {
                                      key: comment.id,
                                      staticClass: "container-comment",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          ref: comment.originalComment
                                            ? "originalComment"
                                            : null,
                                          refInFor: true,
                                          staticClass: "comment",
                                          class: {
                                            "has-response":
                                              (comment.comments &&
                                                comment.comments.data &&
                                                comment.comments.data.length) ||
                                              (comment.comment_count &&
                                                comment.comment_count > 0),
                                            hidden: comment.is_hidden,
                                            originalComment:
                                              comment.originalComment,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "picture-user" },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src:
                                                    [comment.from.id] in
                                                      _vm.saveUrlPictureUser &&
                                                    _vm.saveUrlPictureUser[
                                                      comment.from.id
                                                    ]
                                                      ? _vm.saveUrlPictureUser[
                                                          comment.from.id
                                                        ]
                                                      : "img/avatar.jpg",
                                                },
                                              }),
                                              _c("div", {
                                                staticClass: "lineStart",
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "container-content",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "content" },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "name-user",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          comment.from.name
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "p",
                                                    { staticClass: "text" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(comment.message)
                                                      ),
                                                    ]
                                                  ),
                                                  _c("div", {
                                                    staticClass: "media",
                                                  }),
                                                  _c(
                                                    "ContextMenu",
                                                    {
                                                      attrs: {
                                                        options:
                                                          _vm.getOptionComment(
                                                            comment.id,
                                                            comment
                                                          ),
                                                        id: comment.id,
                                                      },
                                                      on: {
                                                        clickOption:
                                                          _vm.clickOptionComment,
                                                      },
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass: "btn-more",
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "info-content" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "date" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.dateFormat(
                                                            comment.created_time
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "action" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "reaction",
                                                          class: {
                                                            "have-liked":
                                                              comment.user_likes,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.toggleLikeComment(
                                                                comment.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "J'aime " +
                                                              _vm._s(
                                                                comment.like_count
                                                                  ? ` (${comment.like_count})`
                                                                  : ""
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "answer",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.startResponseComment(
                                                                comment.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("Répondre")]
                                                      ),
                                                      comment.from.id !==
                                                        _vm.page.network_id &&
                                                      comment.can_reply_privately !==
                                                        false
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "private-message",
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.startPrivateMessage(
                                                                      comment.id,
                                                                      comment
                                                                        .from
                                                                        .name
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Message privé"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      comment.comments &&
                                      comment.comments.data &&
                                      comment.comments.data.length
                                        ? _vm._l(
                                            comment.comments.data,
                                            function (
                                              subComment,
                                              indexSubComment
                                            ) {
                                              return indexSubComment == 0 ||
                                                subComment.id !==
                                                  _vm.event.data.changes.value
                                                    .comment_id
                                                ? _c(
                                                    "div",
                                                    {
                                                      key: subComment.id,
                                                      ref: subComment.originalComment
                                                        ? "originalComment"
                                                        : null,
                                                      refInFor: true,
                                                      staticClass:
                                                        "comment response",
                                                      class: {
                                                        end:
                                                          comment.comment_count ==
                                                            indexSubComment +
                                                              1 ||
                                                          (!comment.comments
                                                            .data[
                                                            indexSubComment + 1
                                                          ] &&
                                                            !comment.comments
                                                              .paging.next),
                                                        hidden:
                                                          subComment.is_hidden,
                                                        originalComment:
                                                          subComment.originalComment,
                                                      },
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "jonction-line line-continuous",
                                                      }),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "picture-user",
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src:
                                                                [
                                                                  subComment
                                                                    .from.id,
                                                                ] in
                                                                  _vm.saveUrlPictureUser &&
                                                                _vm
                                                                  .saveUrlPictureUser[
                                                                  subComment
                                                                    .from.id
                                                                ]
                                                                  ? _vm
                                                                      .saveUrlPictureUser[
                                                                      subComment
                                                                        .from.id
                                                                    ]
                                                                  : "img/avatar.jpg",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "container-content",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "content",
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "name-user",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      subComment
                                                                        .from
                                                                        .name
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "text",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      subComment.message
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("div", {
                                                                staticClass:
                                                                  "media",
                                                              }),
                                                              _c(
                                                                "ContextMenu",
                                                                {
                                                                  attrs: {
                                                                    options:
                                                                      _vm.getOptionComment(
                                                                        subComment.id,
                                                                        subComment
                                                                      ),
                                                                    id: subComment.id,
                                                                  },
                                                                  on: {
                                                                    clickOption:
                                                                      _vm.clickOptionComment,
                                                                  },
                                                                },
                                                                [
                                                                  _c("div", {
                                                                    staticClass:
                                                                      "btn-more",
                                                                  }),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "info-content",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "date",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.dateFormat(
                                                                        subComment.created_time
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "action",
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "reaction",
                                                                      class: {
                                                                        "have-liked":
                                                                          subComment.user_likes,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.toggleLikeComment(
                                                                              subComment.id
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "J'aime"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "answer",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.startResponseComment(
                                                                              comment.id +
                                                                                "," +
                                                                                subComment.id
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Répondre"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  subComment
                                                                    .from.id !==
                                                                    _vm.page
                                                                      .network_id &&
                                                                  subComment.can_reply_privately !==
                                                                    false
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "private-message",
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.startPrivateMessage(
                                                                                  subComment.id,
                                                                                  subComment
                                                                                    .from
                                                                                    .name
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Message privé"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e()
                                            }
                                          )
                                        : _vm._e(),
                                      comment.comments &&
                                      comment.comments.paging &&
                                      comment.comments.paging.next
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "comment response end",
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "jonction-line line-continuous",
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "container-content",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "more-comment",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.getNextResponseComment(
                                                                  indexComment
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Voir plus réponses"
                                                            ),
                                                          ]
                                                        ),
                                                        comment.displayloaderNextComment
                                                          ? _c("div", {
                                                              staticClass:
                                                                "util-loader",
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                : _vm._e()
                            }
                          ),
                          _vm.post.comments.paging &&
                          _vm.post.comments.paging.next
                            ? _c(
                                "span",
                                {
                                  staticClass: "more-comment",
                                  on: { click: _vm.getNextComment },
                                },
                                [
                                  _c("p", [
                                    _vm._v("Voir plus de commentaires"),
                                  ]),
                                  _vm.displayloaderNextComment
                                    ? _c("div", { staticClass: "util-loader" })
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : [
                          _c("p", { staticClass: "no-comment" }, [
                            _vm._v("Aucun commentaire"),
                          ]),
                        ],
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("FormSendMessage", {
        attrs: { activeMedia: false, setAutofocus: _vm.autoFocus },
        on: {
          onSubmitMessage: _vm.sendComment,
          autoFocused: function ($event) {
            _vm.autoFocus = false
          },
        },
      }),
      _vm.responseComment
        ? _c("div", { staticClass: "container-response-comment" }, [
            _c("p", [
              _vm._v("Répondre à "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.getCommentById(_vm.responseComment.split(",").pop())
                      ? _vm.getCommentById(_vm.responseComment.split(",").pop())
                          .from.name
                      : ""
                  )
                ),
              ]),
            ]),
            _c("i", {
              staticClass: "fa-solid fa-circle-xmark",
              on: { click: _vm.stopResponseComment },
            }),
          ])
        : _vm._e(),
      _vm.privateMessageComment
        ? _c(
            "div",
            {
              staticClass:
                "container-response-comment container-private-message",
            },
            [
              _c("p", [
                _vm._v("Message privé à "),
                _c("span", [_vm._v(_vm._s(_vm.privateMessageComment.name))]),
              ]),
              _c("i", {
                staticClass: "fa-solid fa-circle-xmark",
                on: { click: _vm.stopPrivateMessage },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container-none-post" }, [
      _c("div", { staticClass: "none-post" }, [
        _c("p", [_vm._v("Post non disponible")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "container-content-post loading-content" },
      [
        _c("div", { staticClass: "content-post" }, [
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "picture" }),
          ]),
          _c("div", { staticClass: "bar-action-container" }, [
            _c("div", { staticClass: "btns-action" }, [
              _c("div", { staticClass: "reaction" }, [
                _c("i", { staticClass: "fa-regular fa-thumbs-up" }),
                _vm._v(
                  "\n                                réaction\n                            "
                ),
              ]),
              _c("div", { staticClass: "comments" }, [
                _c("i", { staticClass: "fa-regular fa-comment" }),
                _vm._v(
                  "\n                                commentaire\n                            "
                ),
              ]),
              _c("div", { staticClass: "share" }, [
                _c("i", { staticClass: "fa-regular fa-share" }),
                _vm._v(
                  "\n                                partages\n                            "
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "picture-user" }, [
      _c("img", {
        attrs: {
          src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAJElEQVRoge3BAQEAAAjDoPUvfYMItG0BAAAAALwHAAAAwC/VAZFoA/0E7YaAAAAAAElFTkSuQmCC",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "info-content" }, [
      _c("div", { staticClass: "action" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }